var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Defaults from '../Defaults';
var defaults = Defaults.DemographicSetting;
var DemographicSettingFormModel = /** @class */ (function () {
    function DemographicSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        this.disabledPrefecture = false;
        var _a = item, id = _a.id, _b = _a.sex, sex = _b === void 0 ? null : _b, _c = _a.marriage, marriage = _c === void 0 ? null : _c, _d = _a.age, age = _d === void 0 ? null : _d, _e = _a.prefecture, prefecture = _e === void 0 ? null : _e;
        this.id = id;
        this.sex = sex;
        this.marriage = marriage;
        this.age = age;
        this.prefecture = prefecture;
    }
    DemographicSettingFormModel.prototype.removeSex = function () {
        this.sex = null;
        return this;
    };
    DemographicSettingFormModel.prototype.removeMarriage = function () {
        this.marriage = null;
        return this;
    };
    DemographicSettingFormModel.prototype.removeAge = function (index) {
        var _a, _b;
        (_a = this.age) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
        if (((_b = this.age) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            this.age = null;
        }
        return this;
    };
    DemographicSettingFormModel.prototype.removePrefecture = function (index) {
        var _a, _b;
        (_a = this.prefecture) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
        if (((_b = this.prefecture) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            this.prefecture = null;
        }
        return this;
    };
    /**
     * 年代を指定する際にデフォルトで選択されているものを指定する。
     */
    DemographicSettingFormModel.prototype.setDefaultAge = function () {
        this.age = __spreadArray([], defaults.age, true);
    };
    /**
     * 居住地を指定する際にデフォルトで選択されているものを指定する。
     */
    DemographicSettingFormModel.prototype.setDefaultPrefecture = function () {
        this.prefecture = __spreadArray([], defaults.prefecture, true);
    };
    Object.defineProperty(DemographicSettingFormModel.prototype, "isSelected", {
        get: function () {
            return (this.sex !== null ||
                this.marriage !== null ||
                this.age !== null ||
                this.prefecture !== null);
        },
        enumerable: false,
        configurable: true
    });
    return DemographicSettingFormModel;
}());
export { DemographicSettingFormModel };
